import React, { useState, useEffect } from "react";
import { Input, Button, Divider, Modal, Loader } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { LuUser } from "react-icons/lu";
import { IoWarningOutline } from "react-icons/io5";
import { TbDatabaseOff } from "react-icons/tb";
import EditIcon from "../svg/editIcon";
import TrashIcon from "../svg/trashIcon";
import { useDebouncedValue } from "@mantine/hooks";
import { IoSearchOutline } from "react-icons/io5";

import { MdAdd } from "react-icons/md";
import PermissionAction from "../components/permissions/PermissionAction";
import Container from "../components/Container";
import { useAppDispatch } from "../redux/hooks";
import { setBreadcrumb } from "../redux/slices/breadCrumb.slice";
import { MdOutlineAlternateEmail } from "react-icons/md";
import {
  useGetAlertEmailQuery,
  useEditAlertEmailMutation,
  useAddAlertEmailMutation,
  useLazyGetAlertEmailQuery,
  useDeleteAlertEmailMutation,
} from "../redux/slices/api.slice";

const Alerts = () => {
  const [getEmailALerts, { isFetching, isError, data }] =
    useLazyGetAlertEmailQuery();

  const [deleteEmailAlertHandler, { isLoading: isLoadingDeleteEmail }] =
    useDeleteAlertEmailMutation();
  const [
    addEmailAlertHandler,
    { isLoading: isLoadingaddEmail, isError: isErroraddEmail },
  ] = useAddAlertEmailMutation();
  const [emailsList, setEmailLists] = useState([]);
  const [search, setSearch] = useState("");
  const [addEmailAlert, setAddEmailAlert] = useState({
    open: false,
    email: "",
  });
  const [deleteEmailAlert, setDeleteEmailAlert] = useState({
    open: false,
    id: "",
  });
  const [debounced] = useDebouncedValue(search, 500);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [limit, setLimit] = useState(10);
  const [token, setToken] = useState([]);

  const dispatch = useAppDispatch();
  useEffect(() => {
    const crumbs = [
      {
        name: "Home",
        route: "/",
      },
      {
        name: "Alerts",
        route: "/alerts",
      },
    ];
    dispatch(setBreadcrumb(crumbs));
  }, [dispatch]);

  useEffect(() => {
    getEmailALerts({ paginationToken: null, searchQuery: debounced });
  }, [debounced]);

  useEffect(() => {
    if (currentPage === 1 && data?.emails) {
      setLimit(data.emails.length);
    }
  }, [data]);
  useEffect(() => {
    if (data) {
      setEmailLists(data.emails || []);
      setTotalPages(Math.ceil(data.count / limit));
      setToken((prevToken) => {
        const exists = prevToken.find(
          (item) =>
            item.page === currentPage ||
            item.t === data.nextPaginationToken?.email
        );
        if (!exists) {
          return [
            ...prevToken,
            { page: currentPage, t: data.nextPaginationToken?.email || null },
          ];
        }
        return prevToken;
      });
    }
  }, [data, limit]);
  
  const handleAddEmailAlert = async () => {
    try {
      const result = await addEmailAlertHandler(addEmailAlert.email);

      //@ts-ignore
      if (result.data) {
        notifications.show({
          title: "Success",
          message: "user added successfuly",
          color: "green",
        });
      } else {
        notifications.show({
          title: "Error",
          message: "something went wrong , try again!",
          color: "red",
        });
      }
    } catch (err) {
      notifications.show({
        title: "Error",
        message: "something went wrong , try again!",
        color: "red",
      });
    }

    setAddEmailAlert({ email: "", open: false });
  };
  const handleDeleteEmailAlert = async () => {
    try {
      const result = await deleteEmailAlertHandler({ id: deleteEmailAlert.id });
      //@ts-ignore
      if (result.data) {
        notifications.show({
          title: "Success",
          message: "User removed successfuly",
          color: "green",
        });
      } else {
        notifications.show({
          title: "Error",
          message: "something went wrong , try again!",
          color: "red",
        });
      }
    } catch (error) {
      notifications.show({
        title: "Error",
        message: "something went wrong , try again!",
        color: "red",
      });
    }
    setDeleteEmailAlert({ ...deleteEmailAlert, open: false });
  };
  const handleNext = () => {
    const nextpage = currentPage + 1;
    const currentToken = token.find((t) => t.page === currentPage)?.t;
    getEmailALerts({ paginationToken: currentToken, searchQuery: debounced });

    setCurrentPage(nextpage);
  };

  const handlePrev = () => {
    const prevPage = currentPage - 1;
    const currentToken = token.find((t) => t.page === prevPage - 1)?.t;

    getEmailALerts({
      paginationToken: prevPage === 1 ? null : currentToken,
      searchQuery: debounced,
    });

    setCurrentPage(prevPage);
  };

  return (
    <PermissionAction operation="R" resource="users">
      <Container>
        <div>
          <div className=" flex items-center justify-between ">
            <div className="flex gap-4 items-end">
              <h1 className="font-[500] text-5xl"> Alerts</h1>
              <span className="text-grayText4 text-5xl">{data?.count}</span>
            </div>
            <div className="flex items-center gap-4">
              <Input
                placeholder="Search"
                size="md"
                radius={"md"}
                className="!w-[220px]"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                leftSection={<IoSearchOutline />}
              />

              <PermissionAction operation="C" resource="users">
                <Button
                  color={"#FB6514"}
                  radius="md"
                  size="md"
                  onClick={() => {
                    setAddEmailAlert({ ...addEmailAlert, open: true });
                  }}
                >
                  <MdAdd size={20} />
                  <span>Add User</span>
                </Button>
              </PermissionAction>
            </div>
          </div>
          <p className="text-xl text-grayText5 my-2">
            Manage the list of users who receive email alerts.
          </p>
        </div>
        <div className="  mt-12   border border-grayText4 border-solid rounded-[10px] ">
          {isFetching ? (
            <div className="h-[350px] w-full  flex justify-center items-center">
              <Loader />
            </div>
          ) : isError ? (
            <div className="h-[350px] w-full  flex justify-center items-center">
              Error Fetching data
            </div>
          ) : emailsList.length === 0 ? (
            <div className="h-[350px] w-full  flex justify-center items-center">
              <div className="flex flex-col gap-4 text-grayText2 items-center">
                <TbDatabaseOff className="text-4xl" />
                <span className="text-xl">No data available </span>
              </div>
            </div>
          ) : (
            <div className="flex flex-col  ">
              {emailsList.map((email, index) => {
                return (
                  <div key={email.email}>
                    <ListItem
                      item={email.email}
                      deleteEmailAlert={deleteEmailAlert}
                      setDeleteEmailAlert={setDeleteEmailAlert}
                      idx={index}
                    />
                    {index < emailsList.length - 1 && (
                      <Divider size="xs" color="#e8ebee" />
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {emailsList.length !== 0 && !isError && (
            <div className="w-full flex gap-4 justify-between items-center py-4 px-6 border-top">
              <div className="flex gap-4 items-center">
                <button
                  disabled={currentPage === 1}
                  onClick={handlePrev}
                  className={`btn ${
                    currentPage === 1
                      ? "bg-[#F7F8F9] text-lightGray2 cursor-not-allowed"
                      : "bg-white text-grayText hover:bg-grayText4  "
                  }`}
                >
                  Previous
                </button>
                <button
                  onClick={handleNext}
                  disabled={currentPage === totalPages}
                  className={`btn ${
                    currentPage === totalPages
                      ? "bg-[#F7F8F9] text-lightGray2 cursor-not-allowed"
                      : "bg-white text-grayText hover:bg-grayText4"
                  }`}
                >
                  Next
                </button>
              </div>
              <div className="text-base text-grayText">
                Page {currentPage} of {totalPages}
              </div>
            </div>
          )}
        </div>

        <EmailAlertManageModal
          open={addEmailAlert.open}
          handleClose={() => {
            setAddEmailAlert({ email: "", open: false });
          }}
          title={"Invite a user"}
          desc={
            "Send an invitation link to a user so they can start receiving email alerts"
          }
          inputValue={addEmailAlert.email}
          handleConfirm={handleAddEmailAlert}
          handleInputChange={(value) =>
            setAddEmailAlert({ ...addEmailAlert, email: value })
          }
          isLoading={isLoadingaddEmail}
        />
        <EmailAlertDeleteModal
          open={deleteEmailAlert.open}
          handleClose={() => {
            setDeleteEmailAlert({ ...deleteEmailAlert, open: false });
          }}
          deletedAddress={deleteEmailAlert.id}
          title={"Delete a user "}
          handleConfirm={handleDeleteEmailAlert}
          isLoading={isLoadingDeleteEmail}
        />
      </Container>
    </PermissionAction>
  );
};

export default Alerts;

const ListItem = ({ item, deleteEmailAlert, setDeleteEmailAlert, idx }) => {
  return (
    <div
      className={`flex items-center justify-between py-3 px-6 hover:bg-[#F5F7F9] cursor-pointer ${
        idx === 0 ? "rounded-t-[10px]" : ""
      }`}
    >
      <div className="flex items-center gap-4">
        <div className="bg-[#e8ebee] rounded-xl w-10 h-10 flex items-center justify-center">
          <LuUser className="text-xl text-grayText2" />
        </div>
        <p>{item}</p>
      </div>
      <div className="flex items-center gap-3">
        <div
          className="cursor-pointer flex justify-center items-center "
          onClick={() =>
            setDeleteEmailAlert({
              ...deleteEmailAlert,
              id: item,
              open: true,
            })
          }
        >
          <TrashIcon />
        </div>
      </div>
    </div>
  );
};

const EmailAlertManageModal = ({
  open,
  handleClose,
  title,

  desc,
  inputValue,
  handleConfirm,
  handleInputChange,
  isLoading,
}) => {
  const [emailError, setEmailError] = useState("");

  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };

  const handleInputChangeWithValidation = (value) => {
    handleInputChange(value);
  };

  const handleConfirmWithValidation = () => {
    if (validateEmail(inputValue)) {
      handleConfirm();
    } else {
      setEmailError("Invalid Email");
    }
  };

  return (
    <Modal
      opened={open}
      onClose={handleClose}
      centered
      size="md"
      withCloseButton={false}
      radius={20}
    >
      <div className="py-5 px-4 flex flex-col  justify-center items-center text-center">
        <h4 className="text-4xl font-medium text-grayText7">{title}</h4>
        <p className="text-lg mt-2 mb-6 text-grayText5">{desc}</p>

        <div className="mb-8 w-full">
          <Input
            value={inputValue}
            radius="sm"
            placeholder="Email address"
            type="text"
            error={emailError && emailError}
            size="md"
            onBlur={() => {
              setEmailError(validateEmail(inputValue) ? "" : "Invalid Email");
            }}
            leftSection={<MdOutlineAlternateEmail />}
            className="w-full"
            onChange={(e) =>
              handleInputChangeWithValidation(e.currentTarget.value)
            }
          />
          {emailError && (
            <p className="text-red-500 text-sm mt-1 text-start">{emailError}</p>
          )}
        </div>
        <div className="flex gap-6 ">
          <Button
            color="#D5DAE1"
            onClick={handleClose}
            variant="default"
            size="md"
            radius={"md"}
          >
            Cancel
          </Button>
          <Button
            color="#FB6514"
            size="md"
            type="submit"
            loaderProps={{ type: "dots" }}
            loading={isLoading}
            radius={"md"}
            onClick={handleConfirmWithValidation}
          >
            Confirm
          </Button>
        </div>
      </div>
    </Modal>
  );
};

const EmailAlertDeleteModal = ({
  open,
  handleClose,
  title,
  deletedAddress,
  handleConfirm,
  isLoading,
}) => {
  return (
    <Modal
      opened={open}
      onClose={handleClose}
      centered
      size="md"
      withCloseButton={false}
      radius={20}
    >
      <div className="py-5 px-4 text-center  flex justify-center items-center flex-col">
        <div className="flex items-center justify-center rounded-full w-14 h-14 bg-actionLight">
          <IoWarningOutline className="text-action text-3xl" />
        </div>
        <h4 className=" text-2xl font-medium mt-2 mb-1 text-grayText7">
          Are you sure ?{" "}
        </h4>
        <p className="text-lg mt-2 mb-6 text-grayText5 text-center">
          This will remove the user with address{" "}
          <span className="font-md px-1 text-grayText7"> {deletedAddress}</span>
          from the recipient list of email alerts.
        </p>

        <div className=" flex gap-6">
          <Button
            color="#D5DAE1"
            onClick={handleClose}
            variant="default"
            size="md"
            radius={"md"}
          >
            Cancel
          </Button>
          <Button
            color="#FB6514"
            size="md"
            type="submit"
            radius={"md"}
            loaderProps={{ type: "dots" }}
            loading={isLoading}
            onClick={handleConfirm}
          >
            Confirm
          </Button>
        </div>
      </div>
    </Modal>
  );
};
